import { CgExternal } from 'react-icons/cg';
import { FaAngleDoubleLeft } from 'react-icons/fa';
import { FC } from 'react';

interface CappexProps {
  handlePrevious?: () => void;
}

const Cappex: FC<CappexProps> = ({ handlePrevious }) => {
  const appilyUrl =
    'http://tracking.appily.com/aff_c?offer_id=181&aff_id=2195&aff_sub=PHASE2';

  const handleBack = () => {
    handlePrevious?.();
  };

  const clickHandler = () => {
    window.open(appilyUrl, '_blank');
  };
  return (
    <div className='relative w-full h-full min-h-[500px] bg-white'>
      <div
        className='h-full w-full bg-white relative hidden md:block'
        data-testid='cappex-background-image'
      >
        <img
          src='https://res.cloudinary.com/highereducation/image/upload/c_scale,w_1440/v1684422028/Cappex/LandingPage.jpg'
          alt='woman in a library holding books to her chest and looking at camera'
          className='h-full w-full object-contain'
        />
      </div>
      <div className='md:absolute inset-0 flex h-full w-full flex-col items-center justify-center lg:ml-8 xl:ml-60'>
        <section className='md:relative w-full max-w-full flex flex-col p-12 md:gap-2'>
          <button
            type='button'
            className='flex items-center gap-2 py-1 text-primary-500 text-sm md:text-sm mb-4 md:mb-0'
            onClick={handleBack}
          >
            <FaAngleDoubleLeft className='text-sm md:text-sm' />
            Back to previous question
          </button>
          <h3 className='text-primary-500 max-w-full text-2xl md:text-2xl font-medium leading-tight'>
            Continue with Appily to get your best results!
          </h3>
          <p className='text-primary-500 mt-3 md:mt-1 max-w-full text-base md:text-lg md:max-w-md leading-relaxed'>
            We&apos;re{' '}
            <b className='text-secondary-700'>partnering with Appily</b> to help
            students like you find the right college for your goals and future.
            Finish this quiz on their site to get personalized matches.
          </p>
          <h6 className='text-primary-500 mt-4 md:mt-2 text-lg md:text-lg font-semibold'>
            Find a College in 3 Easy Steps
          </h6>

          <ul className='ml-5 mt-2 md:mt-1 text-primary-600 text-base md:text-sm space-y-1'>
            <li className='list-item max-w-full list-disc md:max-w-md leading-relaxed'>
              Continue this quiz on the Appily website
            </li>
            <li className='list-item max-w-full list-disc md:max-w-md leading-relaxed'>
              Create your FREE account
            </li>
            <li className='list-item max-w-full list-disc md:max-w-md leading-relaxed'>
              Connect with colleges
            </li>
          </ul>

          <p className='mt-3 md:mt-1 max-w-full text-primary-600 md:max-w-md text-base md:text-sm leading-relaxed'>
            Once you&apos;ve created your account, you can even view your
            application status!
          </p>
          <a data-testid='cappex-cta-anchor'>
            <button
              data-testid='cappex-cta-button'
              onClick={clickHandler}
              type='button'
              className='rounded bg-secondary-700 mt-6 md:mt-auto flex items-center justify-center gap-2 py-3 px-6 md:px-3 font-bold text-white text-base md:text-sm'
            >
              Find Your Match{' '}
              <CgExternal className='text-xl md:text-xl text-white' />
            </button>
          </a>
        </section>
      </div>
    </div>
  );
};
export default Cappex;
